
// src/app/project-display/project-display.states.ts
import { Ng2StateDeclaration, Transition, StateRegistry } from '@uirouter/angular';
import { Observable } from 'rxjs';
import { ProjectDisplayContainerComponent } from './feature/project-display-container/project-display-container.component';
import { ProjectDataService } from './data-access/project-data.service';
import { IProject } from './interfaces/IProject';

/**
 * New Angular version of the project details state.
 */
export const projectDisplayStateAngular: Ng2StateDeclaration = {
    name: 'search.projectNew',
    url: '^/project/:projectID/:projectName',
    component: ProjectDisplayContainerComponent,
    data: { requiresAuth: true },
    resolve: [
        {
            token: 'projectId',
            deps: [Transition],
            resolveFn: (transition: Transition): number => transition.params().projectID,
        },
        {
            token: 'project$',
            deps: [Transition, ProjectDataService],
            resolveFn: (transition: Transition, ds: ProjectDataService): Observable<IProject> =>
                ds.getProject(transition.params().projectID),
        },
    ],
};

/**
 * Legacy AngularJS version of the project details state.
 * Kept for fallback when the feature flag disables the new display.
 */
export const projectDisplayStateAngularJs: any = {
    name: 'search.project',
    url: '/project/:projectID/:projectName',
    controller: 'ProjectController',
    templateUrl: '../app-ds3/search/project.partial.html',
    data: { requiresAuth: true },
};

/**
 * Optional asset details state (Angular).
 */
export const assetDisplayState: Ng2StateDeclaration = {
    name: 'assets.detail',
    url: '/assets/:assetId/:assetName',
    component: ProjectDisplayContainerComponent,
    data: { requiresAuth: true },
    resolve: {
        assetId: ['$stateParams', ($stateParams) => parseInt($stateParams.assetId, 10)],
    },
};

/**
 * A tiny, DI-free helper that registers the correct states at runtime.
 * Call this from an APP_INITIALIZER (or any place with access to StateRegistry and feature slice).
 */
export function registerProjectStates(
    registry: StateRegistry,
    features: { useNewProjectDisplay: boolean; enableAssetDisplay: boolean }
): void {
    if (!registry.get(projectDisplayStateAngularJs.name)) {
        registry.register(projectDisplayStateAngularJs as any);
    }

    if (!registry.get(projectDisplayStateAngular.name)) {
        registry.register(projectDisplayStateAngular as any);
    }

    if (features.enableAssetDisplay && !registry.get(assetDisplayState.name)) {
        registry.register(assetDisplayState);
    }
}



// import { Ng2StateDeclaration, Transition } from "@uirouter/angular";
// import { ProjectDisplayContainerComponent } from "./feature/project-display-container/project-display-container.component";
// import { ProjectDataService } from "./data-access/project-data.service";
// import { Observable } from "rxjs";
// import { IProject } from "./interfaces/IProject";
// import { environment } from "src/environments/environment";



// // this state should be included if
// //      useNewProjectDisplay is set to true
// // conversely, the oldd route setting should be used if
// //      useNewProjectDisplay is set to false: Ng2StateDeclaration
// let projectDisplayState = {};

// if (environment.features.useNewProjectDisplay) {
//     projectDisplayState = {
//         name: "search.project",
//         url: '/project/:projectID/:projectName',
//         component: ProjectDisplayContainerComponent,
//         // Mark this state as requiring authentication.  See ../global/requiresAuth.hook.js.
//         data: { requiresAuth: true },
//         resolve: [
//             {
//                 token: 'projectId',
//                 deps: [Transition],
//                 resolveFn: (transition: Transition): number => transition.params().projectID
//             },
//             {
//                 token: 'project$',
//                 deps: [Transition, ProjectDataService],
//                 resolveFn: (transition: Transition, ds: ProjectDataService): Observable<IProject> =>
//                     ds.getProject(transition.params().projectID)
//             },
//         ]
//     };
// }
// else {
//     projectDisplayState = {
//         name: "search.project",
//         url: '/project/:projectID/:projectName',
//         controller: 'ProjectController',
//         templateUrl: "../app-ds3/search/project.partial.html",
//         data: { requiresAuth: true }
//     };
// }


// export let PROJECT_STATES = [
//     projectDisplayState
// ]

// if (environment.features.enableAssetDisplay) {
//     // projectDisplayState = {
//     //     name: "search.project",
//     //     url: '/project/:projectID/:projectName',
//     //     component: ProjectDisplayContainerComponent,
//     //     // Mark this state as requiring authentication.  See ../global/requiresAuth.hook.js.
//     //     data: { requiresAuth: true },
//     //     resolve: [
//     //         {
//     //             token: 'projectId',
//     //             deps: [Transition],
//     //             resolveFn: (transition: Transition): number => transition.params().projectID
//     //         },
//     //         {
//     //             token: 'project$',
//     //             deps: [Transition, ProjectDataService],
//     //             resolveFn: (transition: Transition, ds: ProjectDataService): Observable<IProject> =>
//     //                 ds.getProject(transition.params().projectID)
//     //         },
//     //     ]
//     // };

//     let  assetDisplayState = {
//         name: 'assets.detail',
//         url: '/assets/:assetId/:assetName',
//         component: ProjectDisplayContainerComponent,
//         // Mark this state as requiring authentication. See ../global/requiresAuth.hook.js.
//         data: { requiresAuth: true },
//         resolve: {
//             assetId: ['$stateParams', ($stateParams) => parseInt($stateParams.assetId, 10)]
//         }
//     };
//     PROJECT_STATES.push(assetDisplayState);
// }


// // export const reportsState = {
// //     name: 'reports',
// //     url: '/reports',
// //     template: "<div ui-view></div>",
// //     // Mark this state as requiring authentication.  See ../global/requiresAuth.hook.js.
// //     data: { requiresAuth: true },
// //     resolve: []
// // };



// // export const insightReportsState: Ng2StateDeclaration = {
// //     name: 'reports.insightReports',
// //     url: '/insight',
// //     component: ReportLibraryComponent,
// //     // Mark this state as requiring authentication.  See ../global/requiresAuth.hook.js.
// //     data: { requiresAuth: true },
// //     resolve: [
// //         {
// //             token: 'reportType$',
// //             deps: [ReportLibraryDataService],
// //             resolveFn: (ds: ReportLibraryDataService): Observable<IReportType> => ds.getReportType('insight')
// //         }
// //     ]
// // };
